export default "__VITE_ASSET__cc2e836f__"